import api from "./Api";

class TabelaCodTribNacService {
  GetTabelaCodTribNac(payload) {
    return api.get("/v1/tabelaCodTribNac/" + payload).then((response) => {
      return response.data;
    });
  }

  PostTabelaCodTribNac(payload) {
    return api.post("/v1/tabelaCodTribNac/", payload).then((response) => {
      return response.data;
    });
  }

  PutTabelaCodTribNac(payload) {
    return api.put("/v1/tabelaCodTribNac/", payload).then((response) => {
      return response.data;
    });
  }

  DeleteTabelaCodTribNac(payload) {
    return api.delete("/v1/tabelaCodTribNac/" + payload).then((response) => {
      return response.data;
    });
  }

  GetTabelaCodTribNacOData(payload) {
    return api.get("/OData/TabelaCodTribNac" + payload).then((response) => {
      return response.data;
    });
  }

  AtualizarTabelaCodTribNac(payload) {
    return api
      .post("/v1/tabelaCodTribNac/AtualizarTabelaCodTribNac", payload)
      .then((response) => {
        return response.data;
      });
  }
}

export default new TabelaCodTribNacService();
